import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'artifact-ui', {
    artifactStreaming: 'Streaming…',
    artifactInvalidFence: 'Invalid artifact fence',
    artifactOpenFullscreen: 'Open fullscreen',
    artifactRefresh: 'Refresh',
    artifactCopy: 'Copy to clipboard',
    artifactCopied: 'Copied!',
    artifactCopyFailed: 'Failed to copy to clipboard',
    artifactDownload: 'Download',
    artifactHideInline: 'Hide inline',
    artifactShowInline: 'Show inline',
    artifactClosePanel: 'Close panel',
    artifactCloseFullscreen: 'Close fullscreen',
    artifactEditSource: 'Edit source',
    artifactEditSourceDialogTitle: 'Edit artifact source',
    cancel: 'Cancel',
    save: 'Save',
    artifactKept: 'Artifact kept',
    artifactUnkept: 'Artifact unkept',
    artifactTrashed: 'Artifact trashed',
    artifactRestoreFailed: 'Could not restore the artifact',
    artifactKeep: 'Keep',
    artifactUnkeep: "Don't keep",
    artifactTrash: 'Trash artifact',
    artifactDelete: 'Delete artifact',
    artifactDeleteConfirmTitle: 'Delete artifact?',
    artifactDeleteConfirmDescription:
      'This will permanently delete the artifact. This action cannot be undone.',
  });
}
